"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileRecord = exports.MediaMetaData = void 0;
class MediaMetaData {
}
exports.MediaMetaData = MediaMetaData;
class FileRecord {
}
exports.FileRecord = FileRecord;
